<template>
  <div>
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      :return-value.sync="internalDate"
      transition="scale-transition"
      offset-y
      min-width="auto"
      class="mt-0 pt-0"
    >
      <template #activator="{ on, attrs }">
        <v-text-field
          v-model="dateFormatted"
          v-mask="'##.##.####'"
          :disabled="disabled"
          class="mt-1 rounded-lg py-0 mini-text field-edit"
          outlined
          dense
          :class="errorMessages && errorMessages.length ? 'field-error' : ''"
          :label="keyValue"
          :clearable="clearable"
          :hide-details="hideDetails"
          :height="20"
          :hint="hint"
          :persistent-hint="persistentHint"
          v-bind="attrs"
          :error-messages="errorMessages"
          v-on="on"
          @change="setDate"
          @click:clear="clear"
          @blur="$emit('blur')"
        />
      </template>
      <v-date-picker
        v-model="internalDate"
        locale="ru-RU"
        color="green primary"
        format="DD.MM.YYYY"
        first-day-of-week="1"
        no-title
        scrollable
        @input="save(internalDate)"
      />
    </v-menu>
  </div>
</template>

<script>
import { dateFormat } from '@/scripts/validation'

export default {
  name: 'DateInput',

  props: {
    disabled: { type: Boolean, default: false },
    hideDetails: { type: Boolean, default: false },
    clearable: { type: Boolean, default: true },
    placeholder: { type: String, default: 'Выберите значение' },
    errorMessages: { type: Array, default: () => [] },
    hint: { type: String, default: '' },
    persistentHint: { type: Boolean, default: true },

    modelValue: { type: [String, null], default: null },
    keyValue: { type: String, default: '' },
  },

  data() {
    return {
      menu: false,
      internalDate: this.modelValue || null,
      dateFormatted: this.formatDate(this.modelValue),
    }
  },

  methods: {
    formatDate(date) {
      if (!date) return ''
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },

    clear() {
      this.internalDate = null
      this.save(null)
    },

    save(date) {
      this.menu = false
      this.$nextTick(() => {
        this.dateFormatted = this.formatDate(date)
      })
      this.$emit('input', date)
    },

    setDate(newDate) {
      if (!newDate) {
        this.save(null)
        return
      }

      const parts = newDate.split('.')
      if (parts.length !== 3) {
        this.dateFormatted = this.formatDate(this.internalDate)
        return
      }

      const [day, month, year] = parts
      const isoDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`

      if (dateFormat(isoDate)) {
        this.internalDate = isoDate
        this.save(isoDate)
      } else {
        this.dateFormatted = this.formatDate(this.internalDate)
      }
    },
  },

  watch: {
    modelValue(newVal) {
      this.internalDate = newVal
      this.$nextTick(() => {
        this.dateFormatted = newVal ? this.formatDate(newVal) : ''
      })
    },

    internalDate(newVal) {
      this.dateFormatted = this.formatDate(newVal)
    },
  },
}
</script>
